import { ServiceType } from './ServiceType';

function getStatusDataByServiceType(storeProps, serviceType) {
  if (!storeProps) return null;

  if (serviceType === ServiceType.PICKUP) 
    return storeProps.pickUpStatusData;
  
  return storeProps.deliveryStatusData;
}

export default getStatusDataByServiceType;